<template>
    <el-dialog
    :title="title"
    append-to-body
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
    top="5vh"
    v-if="visible"
    center
  >
    <avue-crud
      ref="avueCrud"
      :option="option"
      v-model="form"
      :data="tableData"
      :search.sync="search"
      :table-loading="TABLE_LOADING"
      :page.sync="TABLE_PAGE"
      @search-change="SEARCH_CHANGE"
      @refresh-change="TABLE_REFRESH"
      @search-reset="SEARCH_RESET"
      @cell-click="CELL_CLICK"
      @selection-change="SELECTION_CHANGE"
      @sort-change="SORT_CHANGE"
      @size-change="SIZE_CHANGE"
      @current-change="CURRENT_CHANGE"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
    >
    </avue-crud>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">确定</el-button>
      <el-button type="info" plain @click="handleClose">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default{
  mixins: [crudPageMinix],
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    title: {
      type: String,
      default: '请选择任务'
    }
  },
  data() {
    return {
      search: {},
      TABLE_LOADING: false,
      option: {
        selection: true,
        border: true,
        dialogDrag: true,
        dialogClickModal: false,
        searchSpan: 12,
        searchMenuSpan: 6,
        index: true,
        indexLabel: '序号',
        align: 'left',
        tip: false,
        header: false,
        stripe: true,
        addBtn: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: '一级任务类型',
            prop: 'zdlx',
            search: true,
            // width: 100,
            type: 'select',
            searchLabelWidth: 100,
            dicData: [],
            props: {
              label: 'name',
              value: 'value'
            }
          },
          {
            label: '一级任务',
            prop: 'yjrwmc',
            search: true,
            searchPlaceholder: '请输入一级任务名称'
          },
          {
            label: '二级任务',
            prop: 'ejrwmc',
            search: true,
            searchPlaceholder: '请输入二级任务名称'
          }

        ]
      },
      form: {},
      tableData: []
    }
  },
  mounted() {
    this.loadData()
    this.getzdlx()
  },
  methods: {
    // 获取字典类型
    getzdlx() {
      this.$http.post('/fighter-workflow-saas/rwxxzd/listDictionaryType').then(res => {
        this.$set(this.option.column[this.findArray(this.option.column, 'zdlx', 'prop')], 'dicData', res.data)
      })
    },
    // 加载表格数据
    loadData(TABLE_PAGE = this.TABLE_PAGE, QUERY_CONDITIONS = this.QUERY_CONDITIONS, TABLE_ORDER = this.TABLE_ORDER, done) {
      this.TABLE_LOADING = true // 表格转圈
      this.SELECT_LIST = [] // 清空选中行
      this.$http.post('/fighter-workflow-saas/rwxxzd/query', null
        , {
          params: {
            zdlx: QUERY_CONDITIONS.zdlx,
            yjrwmc: QUERY_CONDITIONS.yjrwmc,
            ejrwmc: QUERY_CONDITIONS.ejrwmc,
            pageNum: TABLE_PAGE.currentPage,
            pageSize: TABLE_PAGE.pageSize
          }
        }).then(response => {
        let list = response.data.records
        this.RELOAD_CRUD(list)
        this.TABLE_PAGE.total = response.data.total || response.data.records.length
        this.SELECT_LIST = []
      }).catch(error => {
        this.$message.error(error.msg || error.message)
      }).finally(() => {
        this.TABLE_LOADING = false // 表格转圈
        typeof done === 'function' && done()
      })
    },
    handleConfirm() {
      if (this.SELECT_LIST.length === 0) {
        return this.$message.warning('请选择至少一条数据')
      } else if (this.SELECT_LIST.length > 1) {
        this.$message.warning('只能选择一条数据')
      } else {
        this.$emit('onChecked', [...this.SELECT_LIST])
        this.$nextTick(() => {
          this.handleClose()
        })
      }
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
